import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {CurrencyTransformPipe} from "../../../pipes/currency-transform.pipe";

@Component({
    selector: 'app-period-bar-chart',
    templateUrl: './period-bar-chart.component.html',
    styleUrls: ['./period-bar-chart.component.css'],
    providers: [CurrencyTransformPipe]

})
export class PeriodBarChartComponent implements OnInit, AfterViewInit {

    @ViewChild('wrapper')
    public wrapper: ElementRef;

    @ViewChild('canvas')
    public canvas: ElementRef;

    @Input('chartData')
    public chartData = [
        {
            name: 'Period 1',
            value: 200,
        },
        {
            name: 'Period 2',
            value: 300,
        },
        {
            name: 'Period 3',
            value: 400,
        },
        {
            name: 'Period 4',
            value: 500,
        },
        {
            name: 'Period 5',
            value: 600,
        }
    ];

    @Input('height')
    public height = 400;

    @Input('postFix')
    public postFix = '';

    public labelHeight = 50;

    public periodWidth: number;
    private cx: CanvasRenderingContext2D;


    constructor(private currencyPipe: CurrencyTransformPipe) {
    }

    ngOnInit() {
    }

    ngAfterViewInit() {
        const canvasEl: HTMLCanvasElement = this.canvas.nativeElement;
        this.cx = canvasEl.getContext('2d');

        const sections = this.chartData.length;

        if (sections > 3) {
            canvasEl.width = 150 * sections;
        } else {
            canvasEl.width = this.wrapper.nativeElement.offsetWidth;
        }
        canvasEl.height = this.height;


        this.periodWidth = canvasEl.width / sections;
        if (this.periodWidth > 150) {
            this.periodWidth = 150;
        }
        const chartHeight = this.height - this.labelHeight;

        const maxValue = Math.max.apply(Math, this.chartData.map((x) => x['total']));

        // Draw legend
        for (let i = 0; i < this.chartData.length; i++) {

            const period = this.chartData[i];
            const total = period['total'];
            const textStartX = ((this.periodWidth * (i + 1))) - (this.periodWidth / 2)


            this.cx.fillStyle = 'black';
            this.cx.textAlign = 'center';
            this.cx.font = 15 + 'px Arial';
            this.cx.fillText('Period ' + (i + 1), textStartX, this.height - this.labelHeight + 20, this.periodWidth);


            const heightPercent = (total * 100) / maxValue;
            const height = chartHeight * (heightPercent / 100);

            let startY = chartHeight - height;

            const secondHeightPercent = (100 * period['series'][1]['value']) / period['series'][0]['value'];

            const firstHeight = height;
            const secondHeight = height * (secondHeightPercent / 100);


            this.cx.fillStyle = '#96A2A6';
            this.cx.fillRect((this.periodWidth * i) + 10, startY, this.periodWidth - 10, firstHeight);

            // Draw the top text
            this.cx.fillStyle = 'white';
            this.cx.textAlign = 'center';
            const firstTextSize = firstHeight - secondHeight > 25 ? 25 : (firstHeight - secondHeight)/ 2;
            this.cx.font = firstTextSize + 'px Arial';

            const firstText = this.currencyPipe.transform(period['series'][0]['value'], period['postfix']);

            this.cx.fillText(firstText, textStartX + 5, (startY + ((firstHeight - secondHeight) / 2)) + firstTextSize / 3, this.periodWidth - 30);

            startY += firstHeight - secondHeight;

            this.cx.fillStyle = '#C1D0D5';
            this.cx.fillRect((this.periodWidth * i) + 15, startY, this.periodWidth - 20, secondHeight);

            this.cx.fillStyle = 'white';
            const secondTextSize = secondHeight > 25 ? 25 : secondHeight / 2;
            this.cx.font = secondTextSize + 'px Arial';
            const secondText = this.currencyPipe.transform(period['series'][1]['value'], period['postfix']);


            this.cx.fillText(secondText, textStartX + 5, (startY + (secondHeight / 2)), this.periodWidth - 30);

        }
    }
}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/charts/period-bar-chart/period-bar-chart.component.ts